import { CircularProgress, Grid, Paper, Typography } from "@mui/material";
import { useLoadData } from "../../hooks/useLoadData";
import { ApiResponse } from "../../models/api-response";
import { ProfileStatistics } from "../../models/profileStatistics";
import { operationManagementApiKeyStore } from "../../api/masters/operation-management-api-key-store";
import { useSaveData } from "../../hooks/useSaveData";
import { useEffect } from "react";



const styling = {
    paperStyle: { padding: '30px 20px 10px', borderRadius: '10px' },
    countStyle: { color: '#0000b5', fontSize: 50 }
};

interface managementArgs {
    fromDate?: string;
    toDate?: string;
    workOrderStatusID?: number;
}

interface OperationManagementStatics {
    managementArgs: managementArgs;
}

interface ComponentCell {
    label: string;
    value: any;
    isLoading: boolean;
}
const ComponentCell = ({ label, value, isLoading }: ComponentCell) => {
    return (
        <Paper elevation={0} style={styling.paperStyle}>
            <Grid container direction="row" justifyContent="space-between">
                <Grid item display={'flex'}>
                    <Grid container justifyContent="flex-start" alignItems="flex-end">
                        <Typography variant="body1" color="text.secondary">{label}</Typography>
                    </Grid>
                </Grid>
                <Grid item display={'flex'}>
                    <Grid container justifyContent="flex-end" alignItems="flex-end">
                        {!isLoading ? <Typography variant="h4" style={styling.countStyle}>{value}</Typography> : <CircularProgress />}
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    );
}

export const OperationManagementStatics = ({ managementArgs }: OperationManagementStatics) => {

    const { isLoading, data, mutateAsync } = useSaveData<any>(
        operationManagementApiKeyStore.getOperationManagementCounts());
    
      useEffect(() => {
        if (managementArgs) {
            mutateAsync({ data: managementArgs });
        }
      }, [managementArgs])

    return (
        <Grid container spacing={2} className="detailsBoxContainer">
            <Grid item lg={6} sm={6} xl={6} xs={6} className="detailsBox">
                <ComponentCell label="INSPECTION REQUEST" value={data?.data.inspectionRequestsCount} isLoading={isLoading} />
            </Grid>
            <Grid item lg={6} sm={6} xl={6} xs={6} className="detailsBox">
                <ComponentCell label="FORECAST READY" value={data?.data.forecastCount} isLoading={isLoading} />
            </Grid>
            {/* <Grid item lg={3} sm={3} xl={3} xs={3} className="detailsBox">
                <ComponentCell label="PENDING CONFIRMATION" value={data?.data.pendingConfirmationCount} isLoading={isLoading} />
            </Grid> */}
            {/* <Grid item lg={4} sm={4} xl={4} xs={4} className="detailsBox">
                <ComponentCell label="GENERAL WORK ORDERS" value={data?.data.generalWorkOrdersCount} isLoading={isLoading} />
            </Grid> */}
        </Grid>
    );
}